import { Component, ComponentRef, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { NotificationViewModel } from "../Model/NotificationViewModel";
import { NotificationsService } from "../../../../services/notifications.service";
import { CommandsService, CommandTemplateModel } from "../../../../services/commands.service";
import { IManagableObject } from "../../IManagableObject";
import { ObjectsService } from "../../../../services/objects.service";
import { ObjectGroupViewModel } from '../../ObjectGroupViewModel';
import { DialogService } from '../../../../services/dialog.service';
import { ObjectsManagementDialogComponent } from '../../objects-management-dialog/objects-management-dialog.component';
import { ZoneService } from '../../../../services/zones.service';
import { GeozoneViewModel } from '../../Geozone/Model/GeozoneViewModel';

@Component({
    selector: 'app-notifications-dialog-base',
    templateUrl: './notifications-dialog-base.component.html',
    styleUrls: ['./notifications-dialog-base.component.css'],
    standalone: false
})
export class NotificationsDialogBaseComponent extends DialogBaseComponent<NotificationViewModel> {

  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;

  public groups: IManagableObject[] = [];

  protected service: NotificationsService;
  private commandsService: CommandsService;
  private objectsService: ObjectsService;
  private geozoneService: ZoneService;
  private dialogService: DialogService;

  private geozoneGroups: ObjectGroupViewModel[] = [];
  private geozones: GeozoneViewModel[] = [];

  public commands: CommandTemplateModel[] = [];

  public allObjects: IManagableObject[] = [];
  public objectGroups: ObjectGroupViewModel[] = [];

  public openedTabName: string = "main";

  constructor(protected injector: Injector) {
    super(injector);
    this.service = injector.get(NotificationsService);
    this.commandsService = injector.get(CommandsService);
    this.objectsService = injector.get(ObjectsService);
    this.dialogService = injector.get(DialogService);
    this.geozoneService = injector.get(ZoneService);
  }

  public openTab(name: string) {
    this.openedTabName = name;
  }
  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  open(model: NotificationViewModel, type: { new(): NotificationViewModel } = undefined) {
    super.open(model, type);

    this.commandsService.getCommands()
      .subscribe((commands) => {
        this.commands = commands;
      });

    this.service.GetGroups().subscribe(groups => {
      this.groups = groups;
    });
    this.objectsService.GetObjects().subscribe(objects => {
      this.allObjects = objects;
    });
    this.objectsService.GetObjectGroups().subscribe(groups => {
      this.objectGroups = groups;
    });
    this.geozoneService.GetGroups().subscribe(groups => {
      this.geozoneGroups = groups;
    });
    this.geozoneService.GetZones().subscribe(zones => {
      this.geozones = zones;
    });
  }

  public selectGeozones(ids: number[]): void {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);

    this.objectsListDialog.instance.groups = this.geozoneGroups;
    this.objectsListDialog.instance.objects = this.geozones;
    for (var i = 0; i < this.geozones.length; i++)
      this.geozones[i].IsChecked = ids.includes(this.geozones[i].Id);

    this.objectsListDialog.instance.onSubmit.subscribe(() => {
      ids.splice(0, ids.length);
      this.objectsListDialog.instance.objects.forEach(zone => {
        if (zone.IsChecked)
          ids.push(zone.Id);
      });

      this.objectsListDialog.instance.close();
    });

    this.objectsListDialog.instance.open();
  }
  public getGeozonesDescription(ids: number[]): string {
    var res = "";

    for (var i = 0; i < this.geozones.length; i++)
      if (ids.includes(this.geozones[i].Id))
        res += ((res.length > 0) ? "," : "") + this.geozones[i].Name;

    return res;
  }
  public CleanInGeozones(event) {
    this.model.InGeozones = [];
    event.stopPropagation();
    return false;
  }
  public CleanOutGeozones(event) {
    this.model.OutOfGeozones = [];
    event.stopPropagation();
    return false;
  }
  public convertRepeatPeriod(value: number) {
    this.model.RepeatPeriod = value * 3600000;
  }
  public convertMinDurationPeriod(value: number) {
    this.model.MinDuration = value * 1000;
  }

  public convertMinDelayBetween(value: number) {
    this.model.MinDelayBetween = value * 1000;
  }

  public onTypeChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.model.EventType = input.value;
  }

  public hasDuration() {
    return this.model.EventType == 'SPEED' ||
      this.model.EventType == 'NO_DATA' ||
      this.model.EventType == 'OLDCURPOS' ||
      this.model.EventType == 'PARK' ||
      this.model.EventType == 'MOVE' ||

      this.model.EventType == 'IDLING' ||
      this.model.EventType == 'TREND_OUT_OF_SCALE' ||

      this.model.EventType == 'EXITZONE' ||
      this.model.EventType == 'ENTERZONE' ||

      this.model.EventType == 'TREND_VALUE';
  }
  public hasPermittedInterval() {
    return this.model.EventType == 'SPEED' ||
      this.model.EventType == 'TREND_VALUE';
  }
}
